(function () {
  'use strict';

  var UNSAFE_TAGS = {
    SCRIPT: true,
    STYLE: true,
    IFRAME: true,
    OBJECT: true,
    EMBED: true,
    LINK: true,
    META: true
  };

  function normalizeHeading(value) {
    return String(value || '')
      .replace(/[\u2018\u2019\u0060]/g, "'")
      .replace(/&/g, ' and ')
      .trim()
      .replace(/[:;,.!?]+$/g, '')
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseAliases(value) {
    return String(value || '')
      .split(/,|\n/)
      .map(function (alias) {
        return alias.trim();
      })
      .filter(Boolean);
  }

  function getBlockKey(block) {
    var aliases = parseAliases(block.aliases);
    return normalizeHeading(aliases[0] || block.label || block.id).replace(/\s+/g, '-');
  }

  function getConfig(root) {
    var configNode = root.querySelector('[data-custom-qpf-config]');
    var config = {};

    if (!configNode) {
      return config;
    }

    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      config = {};
    }

    config.blocks = (config.blocks || [])
      .filter(function (block) {
        return block && block.enabled !== false && block.label && parseAliases(block.aliases).length;
      })
      .map(function (block, index) {
        block.index = index;
        block.key = getBlockKey(block);
        block.aliasList = parseAliases(block.aliases);
        block.sortOrder = parseInt(block.sortOrder, 10) || index + 1;
        block.width = block.width || 'normal';
        block.layout = block.layout || 'auto';
        block.icon = block.icon || 'spark';
        block.customIcon = normalizeCustomIcon(block.customIcon);
        return block;
      })
      .sort(function (a, b) {
        if (a.sortOrder === b.sortOrder) {
          return a.index - b.index;
        }

        return a.sortOrder - b.sortOrder;
      });

    config.summaryAliases = config.summaryAliases || [
      'Quick Summary',
      'Product Summary',
      'Summary',
      'Quick Product Summary'
    ];
    config.cardArrangement = config.cardArrangement || 'smart';

    return config;
  }

  function normalizeCustomIcon(customIcon) {
    if (!customIcon || !customIcon.url) {
      return null;
    }

    return {
      url: String(customIcon.url),
      alt: customIcon.alt ? String(customIcon.alt) : '',
      width: parseInt(customIcon.width, 10) || null,
      height: parseInt(customIcon.height, 10) || null
    };
  }

  function buildAliasMap(config) {
    var aliasMap = new Map();

    config.summaryAliases.forEach(function (alias) {
      aliasMap.set(normalizeHeading(alias), { type: 'summary' });
    });

    config.blocks.forEach(function (block) {
      block.aliasList.forEach(function (alias) {
        aliasMap.set(normalizeHeading(alias), { type: 'block', block: block });
      });
    });

    return aliasMap;
  }

  function isTabNavElement(element) {
    return Boolean(
      element &&
      element.nodeType === Node.ELEMENT_NODE &&
      element.tagName === 'UL' &&
      element.querySelector('a[href^="#tab-"]')
    );
  }

  function isDescriptionBoundary(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (node.tagName === 'H2' || node.tagName === 'H3') {
      return true;
    }

    if (isTabNavElement(node)) {
      return true;
    }

    return Boolean(node.id && /^tab-\d+/i.test(node.id));
  }

  function sanitizeElement(element) {
    Array.from(element.querySelectorAll('*')).forEach(function (child) {
      if (UNSAFE_TAGS[child.tagName] || isTabNavElement(child)) {
        child.remove();
        return;
      }

      Array.from(child.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase();
        var value = attribute.value.trim().toLowerCase();

        if (name.indexOf('on') === 0 || value.indexOf('javascript:') === 0) {
          child.removeAttribute(attribute.name);
        }
      });
    });

    Array.from(element.attributes).forEach(function (attribute) {
      var name = attribute.name.toLowerCase();
      var value = attribute.value.trim().toLowerCase();

      if (name.indexOf('on') === 0 || value.indexOf('javascript:') === 0) {
        element.removeAttribute(attribute.name);
      }
    });
  }

  function cloneSafeNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.cloneNode(true);
    }

    if (node.nodeType !== Node.ELEMENT_NODE || UNSAFE_TAGS[node.tagName] || isDescriptionBoundary(node)) {
      return null;
    }

    var clone = node.cloneNode(true);
    sanitizeElement(clone);
    return clone;
  }

  function hasContent(fragment) {
    return fragment && fragment.textContent.trim().length > 0;
  }

  function collectContent(heading) {
    var fragment = document.createDocumentFragment();
    var node = heading.nextSibling;

    while (node) {
      if (isDescriptionBoundary(node)) {
        break;
      }

      var clone = cloneSafeNode(node);

      if (clone) {
        fragment.appendChild(clone);
      }

      node = node.nextSibling;
    }

    return fragment;
  }

  function parseSource(source, config) {
    var aliasMap = buildAliasMap(config);
    var parsed = {
      summary: null,
      blocks: new Map()
    };

    Array.from(source.querySelectorAll('h3')).forEach(function (heading) {
      var match = aliasMap.get(normalizeHeading(heading.textContent));

      if (!match) {
        return;
      }

      var content = collectContent(heading);

      if (!hasContent(content)) {
        return;
      }

      if (match.type === 'summary') {
        if (!parsed.summary) {
          parsed.summary = content;
        }

        return;
      }

      if (!parsed.blocks.has(match.block.id)) {
        parsed.blocks.set(match.block.id, {
          block: match.block,
          content: content
        });
      }
    });

    return parsed;
  }

  function createSource(root) {
    var template = root.querySelector('[data-custom-qpf-source-template]');
    var source = document.createElement('div');

    if (!template) {
      return source;
    }

    source.innerHTML = template.innerHTML;
    return source;
  }

  function createSummaryContent(fragment, config) {
    var wrapper = document.createDocumentFragment();
    var content = document.createElement('div');

    if (config.showIcons !== false) {
      var icon = document.createElement('span');
      icon.className = 'custom-quick-product-facts__summary-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = getIcon('spark');
      wrapper.appendChild(icon);
    }

    content.className = 'custom-quick-product-facts__summary-content';
    content.appendChild(fragment);
    wrapper.appendChild(content);

    return wrapper;
  }

  function createSummaryFallback(text, config) {
    var fragment = document.createDocumentFragment();
    var paragraph = document.createElement('p');
    paragraph.textContent = text;
    fragment.appendChild(paragraph);
    return createSummaryContent(fragment, config);
  }

  function isSafetyBlock(block) {
    return block.key === 'safety-highlights';
  }

  function isBudgetBlock(block) {
    return block.key === 'budget-level';
  }

  function isManufacturingBlock(block) {
    return block.key === 'manufacturing-information';
  }

  function isCompactMetaBlock(block) {
    return isBudgetBlock(block) || isManufacturingBlock(block);
  }

  function isSpecBlock(block) {
    return block.key === 'product-dimensions-and-specifications' ||
      block.key === 'product-dimensions' ||
      block.key === 'product-specifications' ||
      block.key === 'dimensions-and-specifications';
  }

  function createCard(block, fragment, root, config) {
    var card = document.createElement('article');
    var header = document.createElement('div');
    var titleWrap = document.createElement('div');
    var title = document.createElement('h3');
    var body = document.createElement('div');

    card.className = 'custom-quick-product-facts__card custom-quick-product-facts__card--' + block.width;
    card.setAttribute('data-custom-qpf-card', block.key);
    card.dataset.customQpfBlockId = block.id;
    card.dataset.customQpfPreferredWidth = block.width;

    if (isCompactMetaBlock(block)) {
      card.classList.add('custom-quick-product-facts__card--compact-meta');
    }

    header.className = 'custom-quick-product-facts__card-header';
    titleWrap.className = 'custom-quick-product-facts__card-title-wrap';

    if (config.showIcons !== false) {
      var icon = document.createElement('span');
      icon.className = 'custom-quick-product-facts__icon';
      icon.setAttribute('aria-hidden', 'true');

      if (block.customIcon) {
        icon.appendChild(createCustomIconImage(block.customIcon));
      } else {
        icon.innerHTML = getIcon(block.icon);
      }

      header.appendChild(icon);
    }

    title.className = 'custom-quick-product-facts__card-title';
    title.textContent = block.label;
    titleWrap.appendChild(title);

    var helperText = String(block.helperText || '').trim();
    if (helperText) {
      var subtitle = document.createElement('p');
      subtitle.className = 'custom-quick-product-facts__card-subtitle';
      subtitle.textContent = helperText;
      titleWrap.appendChild(subtitle);
    }

    header.appendChild(titleWrap);

    body.className = 'custom-quick-product-facts__body';
    body.id = 'custom-qpf-body-' + root.id + '-' + block.key;

    if (isBudgetBlock(block)) {
      renderBudgetContent(body, fragment);
    } else {
      renderCardContent(body, fragment, block.layout);
    }

    if (isSafetyBlock(block)) {
      transformFreeOfLists(body);
    }

    if (isSpecBlock(block)) {
      transformSpecLists(body);
    }

    card.appendChild(header);
    card.appendChild(body);

    return card;
  }

  function getWidthSpan(width) {
    var spans = {
      normal: 4,
      wide: 8,
      'half-strip': 6,
      full: 12
    };

    return spans[width] || spans.normal;
  }

  function getSmartRowWidth(visibleItems) {
    var visibleTotal = visibleItems.reduce(function (total, item) {
      return total + item.span;
    }, 0);

    if (visibleItems.length === 1) {
      return 'full';
    }

    if (visibleItems.length === 2 && visibleTotal < 12) {
      return 'half-strip';
    }

    return null;
  }

  function resetSmartWidths(cards) {
    cards.forEach(function (card) {
      card.classList.remove(
        'custom-quick-product-facts__card--smart-normal',
        'custom-quick-product-facts__card--smart-wide',
        'custom-quick-product-facts__card--smart-half',
        'custom-quick-product-facts__card--smart-full',
        'custom-quick-product-facts__card--smart-row-height'
      );
      delete card.dataset.customQpfEffectiveWidth;
      delete card.dataset.customQpfSmartRow;
      card.style.removeProperty('--custom-qpf-smart-row-height');
    });
  }

  function setSmartWidth(card, width, rowIndex) {
    var className = {
      normal: 'custom-quick-product-facts__card--smart-normal',
      wide: 'custom-quick-product-facts__card--smart-wide',
      'half-strip': 'custom-quick-product-facts__card--smart-half',
      full: 'custom-quick-product-facts__card--smart-full'
    }[width];

    if (!className) {
      return;
    }

    card.classList.add(className);
    card.dataset.customQpfEffectiveWidth = width;
    card.dataset.customQpfSmartRow = String(rowIndex);
  }

  function getPlannedRows(blocks) {
    var rows = [];
    var currentRow = [];
    var currentSpan = 0;

    function pushCurrentRow() {
      if (currentRow.length) {
        rows.push(currentRow);
      }

      currentRow = [];
      currentSpan = 0;
    }

    blocks.forEach(function (block) {
      var span = getWidthSpan(block.width);
      var item = {
        block: block,
        span: span
      };

      if (span === 12) {
        pushCurrentRow();
        rows.push([item]);
        return;
      }

      if (currentSpan + span > 12) {
        pushCurrentRow();
      }

      currentRow.push(item);
      currentSpan += span;

      if (currentSpan === 12) {
        pushCurrentRow();
      }
    });

    pushCurrentRow();
    return rows;
  }

  function applyCardArrangement(cards, config) {
    resetSmartWidths(cards);

    if (config.cardArrangement === 'manual') {
      return;
    }

    var cardsByBlockId = new Map();

    cards.forEach(function (card) {
      cardsByBlockId.set(card.dataset.customQpfBlockId, card);
    });

    getPlannedRows(config.blocks).forEach(function (row, rowIndex) {
      var visibleItems = row
        .map(function (item) {
          return {
            block: item.block,
            card: cardsByBlockId.get(item.block.id),
            span: item.span
          };
        })
        .filter(function (item) {
          return item.card;
        });

      var rowWidth = getSmartRowWidth(visibleItems);

      if (rowWidth) {
        visibleItems.forEach(function (item) {
          setSmartWidth(item.card, rowWidth, rowIndex);
        });
      }
    });
  }

  function createCustomIconImage(customIcon) {
    var image = document.createElement('img');

    image.src = customIcon.url;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';

    if (customIcon.width) {
      image.width = customIcon.width;
    }

    if (customIcon.height) {
      image.height = customIcon.height;
    }

    return image;
  }

  function getSmartRowGroups(cards) {
    var groups = new Map();

    cards.forEach(function (card) {
      var rowKey = card.dataset.customQpfSmartRow;

      if (!rowKey) {
        return;
      }

      if (!groups.has(rowKey)) {
        groups.set(rowKey, []);
      }

      groups.get(rowKey).push(card);
    });

    return Array.from(groups.values());
  }

  function canEqualizeSmartCard(card) {
    return (
      card.dataset.customQpfUseStandardHeight !== 'false' &&
      !card.classList.contains('custom-quick-product-facts__card--compact-meta')
    );
  }

  function equalizeSmartRows(cards) {
    getSmartRowGroups(cards).forEach(function (rowCards) {
      var equalizedCards = rowCards.filter(canEqualizeSmartCard);
      var rowHeight;

      if (!equalizedCards.length) {
        return;
      }

      rowHeight = Math.min.apply(null, equalizedCards.map(function (card) {
        return Math.ceil(card.getBoundingClientRect().height);
      }));

      equalizedCards.forEach(function (card) {
        var body = card.querySelector('.custom-quick-product-facts__body');

        if (!body) {
          return;
        }

        card.style.setProperty('--custom-qpf-smart-row-height', rowHeight + 'px');
        card.classList.add('custom-quick-product-facts__card--smart-row-height');
        body.classList.add('custom-quick-product-facts__body--collapsible');
      });

      equalizedCards.forEach(function (card) {
        var body = card.querySelector('.custom-quick-product-facts__body');

        if (!body) {
          return;
        }

        if (body.scrollHeight > body.clientHeight + 4) {
          makeCardCollapsible(card, body);
        } else {
          body.classList.remove('custom-quick-product-facts__body--collapsible');
        }
      });
    });
  }

  function standardizeCards(cards) {
    equalizeSmartRows(cards);

    cards.forEach(function (card) {
      var body = card.querySelector('.custom-quick-product-facts__body');

      var isCompactMetaCard = card.classList.contains('custom-quick-product-facts__card--compact-meta');

      if (
        !body ||
        card.classList.contains('custom-quick-product-facts__card--smart-row-height') ||
        (!isCompactMetaCard && card.dataset.customQpfUseStandardHeight === 'false')
      ) {
        return;
      }

      card.classList.add('custom-quick-product-facts__card--standardized');
      body.classList.add('custom-quick-product-facts__body--collapsible');

      if (body.scrollHeight > body.clientHeight + 4) {
        makeCardCollapsible(card, body);
      } else {
        body.classList.remove('custom-quick-product-facts__body--collapsible');
      }
    });
  }

  function makeCardCollapsible(card, body) {
    var button = document.createElement('button');
    var text = document.createElement('span');
    var icon = document.createElement('span');

    card.classList.add('custom-quick-product-facts__card--has-overflow');

    button.className = 'custom-quick-product-facts__card-toggle';
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', body.id);

    text.className = 'custom-quick-product-facts__card-toggle-text';
    text.textContent = 'Show details';

    icon.className = 'custom-quick-product-facts__card-toggle-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8l5 5 5-5"></path></svg>';

    button.appendChild(text);
    button.appendChild(icon);

    button.addEventListener('click', function () {
      var isExpanded = card.classList.toggle('custom-quick-product-facts__card--expanded');

      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      text.textContent = isExpanded ? 'Show less' : 'Show details';
    });

    card.appendChild(button);
  }

  function renderBudgetContent(body, fragment) {
    var text = fragment.textContent.trim();
    var colonIndex = text.indexOf(':');

    if (colonIndex > 0 && colonIndex < text.length - 1) {
      var note = document.createElement('div');
      var label = document.createElement('span');
      var value = document.createElement('span');

      note.className = 'custom-quick-product-facts__budget-note';
      label.className = 'custom-quick-product-facts__budget-label';
      value.className = 'custom-quick-product-facts__budget-value';
      label.textContent = text.slice(0, colonIndex).trim() + ':';
      value.textContent = text.slice(colonIndex + 1).trim();

      note.appendChild(label);
      note.appendChild(value);
      body.appendChild(note);
      return;
    }

    renderCardContent(body, fragment, 'standard');
  }

  function renderCardContent(body, fragment, layout) {
    Array.from(fragment.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'UL' && shouldRenderKeyValueList(node, layout)) {
        body.appendChild(createKeyValueList(node, layout === 'key-value-two'));
        return;
      }

      body.appendChild(node);
    });
  }

  function shouldRenderKeyValueList(list, layout) {
    if (layout === 'standard') {
      return false;
    }

    if (layout === 'key-value' || layout === 'key-value-two') {
      return listLooksLikeKeyValue(list);
    }

    return listLooksLikeKeyValue(list);
  }

  function listLooksLikeKeyValue(list) {
    var items = Array.from(list.children).filter(function (child) {
      return child.tagName === 'LI';
    });
    var pairCount = items.filter(parseKeyValueItem).length;

    return items.length > 0 && pairCount / items.length >= 0.65;
  }

  function parseKeyValueItem(item) {
    var strong = item.querySelector('strong, b');

    if (strong && item.firstElementChild === strong) {
      var strongText = strong.textContent.replace(/:\s*$/, '').trim();
      var value = item.textContent.replace(strong.textContent, '').replace(/^:\s*/, '').trim();

      if (strongText && value) {
        return {
          key: strongText,
          value: value
        };
      }
    }

    var text = item.textContent.trim();
    var colonIndex = text.indexOf(':');

    if (colonIndex > 0 && colonIndex < text.length - 1) {
      return {
        key: text.slice(0, colonIndex).trim(),
        value: text.slice(colonIndex + 1).trim()
      };
    }

    return null;
  }

  function createKeyValueList(list, twoColumns) {
    var wrapper = document.createElement('div');
    wrapper.className = 'custom-quick-product-facts__kv-list';

    if (twoColumns) {
      wrapper.className += ' custom-quick-product-facts__kv-list--two';
    }

    Array.from(list.children).forEach(function (item) {
      var pair = parseKeyValueItem(item);

      if (!pair) {
        return;
      }

      var row = document.createElement('div');
      var key = document.createElement('div');
      var value = document.createElement('div');

      row.className = 'custom-quick-product-facts__kv-row';
      key.className = 'custom-quick-product-facts__kv-key';
      value.className = 'custom-quick-product-facts__kv-value';
      key.textContent = pair.key;
      value.textContent = pair.value;

      row.appendChild(key);
      row.appendChild(value);
      wrapper.appendChild(row);
    });

    return wrapper;
  }

  function transformFreeOfLists(body) {
    Array.from(body.querySelectorAll('h4')).forEach(function (heading) {
      if (normalizeHeading(heading.textContent) !== 'free of') {
        return;
      }

      var list = heading.nextElementSibling;

      if (!list || list.tagName !== 'UL') {
        return;
      }

      var freeList = document.createElement('ul');
      freeList.className = 'custom-quick-product-facts__free-list';

      Array.from(list.children).forEach(function (item) {
        if (item.tagName !== 'LI') {
          return;
        }

        var freeItem = document.createElement('li');
        var icon = document.createElement('span');
        var text = document.createElement('span');

        freeItem.className = 'custom-quick-product-facts__free-item';
        icon.className = 'custom-quick-product-facts__free-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="m8.5 8.5 7 7M15.5 8.5l-7 7"></path></svg>';
        text.className = 'custom-quick-product-facts__free-text';
        text.textContent = item.textContent.trim();

        freeItem.appendChild(icon);
        freeItem.appendChild(text);
        freeList.appendChild(freeItem);
      });

      list.replaceWith(freeList);
    });
  }

  function transformSpecLists(body) {
    Array.from(body.querySelectorAll('ul')).forEach(function (list) {
      list.classList.add('custom-quick-product-facts__spec-list');
    });
  }

  function configureShowMore(root, cards, toggle, config) {
    var maxVisible = parseInt(config.maxVisibleBlocks, 10);
    var showMoreEnabled = config.showMoreEnabled === true;

    if (!showMoreEnabled || !Number.isFinite(maxVisible) || cards.length <= maxVisible) {
      cards.forEach(function (card) {
        card.hidden = false;
      });
      return;
    }

    var expanded = false;
    var showText = config.showMoreText || 'Show more';
    var hideText = config.showLessText || 'Show less';

    function sync() {
      cards.forEach(function (card, index) {
        card.hidden = !expanded && index >= maxVisible;
      });

      toggle.hidden = false;
      toggle.textContent = expanded ? hideText : showText;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    toggle.onclick = function () {
      expanded = !expanded;
      sync();
    };

    sync();
  }

  function repairDescriptionTabs(root, config) {
    var selector = config.descriptionSelector || '[data-product-description]';

    Array.from(document.querySelectorAll(selector)).forEach(function (container) {
      if (root.contains(container)) {
        return;
      }

      var tabNav = Array.from(container.querySelectorAll('ul')).find(isTabNavElement);

      if (!tabNav) {
        return;
      }

      Array.from(container.querySelectorAll('ul.tabs')).forEach(function (list) {
        if (list !== tabNav) {
          list.classList.remove('tabs');
        }
      });

      tabNav.classList.add('tabs');
      initializeDescriptionTabs(tabNav);
    });
  }

  function initializeDescriptionTabs(tabNav) {
    if (!tabNav || tabNav.dataset.customQpfTabsInitialized === 'true') {
      return;
    }

    var links = Array.from(tabNav.querySelectorAll('a[href^="#"]'));

    if (!links.length) {
      return;
    }

    tabNav.dataset.customQpfTabsInitialized = 'true';

    function setActive(activeLink) {
      links.forEach(function (link) {
        var panel = document.querySelector(link.getAttribute('href'));
        var isActive = link === activeLink;

        link.classList.toggle('active', isActive);

        if (panel) {
          panel.hidden = !isActive;
          panel.style.display = isActive ? '' : 'none';
        }
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(link);
      });
    });

    setActive(links.find(function (link) {
      return link.classList.contains('active');
    }) || links[0]);
  }

  function hideMatchedSourceSections(root, config) {
    if (config.hideMatchedSourceSections !== true) {
      return;
    }

    var selector = config.descriptionSelector || '[data-product-description]';
    var aliasMap = buildAliasMap(config);

    Array.from(document.querySelectorAll(selector)).forEach(function (container) {
      if (root.contains(container)) {
        return;
      }

      Array.from(container.querySelectorAll('h3')).forEach(function (heading) {
        if (!aliasMap.has(normalizeHeading(heading.textContent))) {
          return;
        }

        hideSourceGroup(heading);
      });
    });
  }

  function hideSourceGroup(heading) {
    var node = heading.nextSibling;
    heading.setAttribute('data-custom-qpf-hidden-source', '');

    while (node) {
      if (isDescriptionBoundary(node)) {
        break;
      }

      var nextNode = node.nextSibling;

      if (node.nodeType === Node.ELEMENT_NODE && !isTabNavElement(node) && !node.querySelector('a[href^="#tab-"]')) {
        node.setAttribute('data-custom-qpf-hidden-source', '');
      }

      node = nextNode;
    }
  }

  function renderRoot(root) {
    var config = getConfig(root);
    var summary = root.querySelector('[data-custom-qpf-summary]');
    var grid = root.querySelector('[data-custom-qpf-grid]');
    var toggle = root.querySelector('[data-custom-qpf-toggle]');
    var source = createSource(root);

    if (!summary || !grid || !toggle) {
      return;
    }

    repairDescriptionTabs(root, config);

    var parsed = parseSource(source, config);
    var cards = [];

    grid.innerHTML = '';
    summary.innerHTML = '';
    summary.hidden = true;
    toggle.hidden = true;
    toggle.onclick = null;

    var summaryFallback = String(config.summaryFallback || '').trim();

    if (parsed.summary && config.summaryEnabled !== false) {
      summary.hidden = false;
      summary.appendChild(createSummaryContent(parsed.summary, config));
    } else if (config.summaryEnabled !== false && summaryFallback) {
      summary.hidden = false;
      summary.appendChild(createSummaryFallback(summaryFallback, config));
    }

    config.blocks.forEach(function (block) {
      var match = parsed.blocks.get(block.id);

      if (!match) {
        return;
      }

      var card = createCard(match.block, match.content, root, config);
      card.dataset.customQpfUseStandardHeight = String(block.useStandardHeight !== false);
      cards.push(card);
      grid.appendChild(card);
    });

    var hasRenderableContent = cards.length > 0 || !summary.hidden || config.forceShow === true;
    root.hidden = !hasRenderableContent;

    if (!hasRenderableContent) {
      return;
    }

    applyCardArrangement(cards, config);
    standardizeCards(cards);
    configureShowMore(root, cards, toggle, config);
    hideMatchedSourceSections(root, config);

    if (config.debugMode && window.console) {
      window.console.info('[Custom Quick Product Facts]', {
        sectionId: config.sectionId,
        cards: cards.map(function (card) {
          return card.getAttribute('data-custom-qpf-card');
        }),
        summary: !summary.hidden
      });
    }
  }

  function getIcon(name) {
    var icons = {
      spark: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="8" fill="currentColor" stroke="none"></circle><path d="M24 3v7M24 38v7M3 24h7M38 24h7M9 9l5 5M34 34l5 5M39 9l-5 5M14 34l-5 5"></path></svg>',
      people: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="16" r="6"></circle><circle cx="33" cy="18" r="5"></circle><path d="M7 38c1-8 6-12 11-12s10 4 11 12"></path><path d="M27 30c3-3 10-2 14 8"></path></svg>',
      droplet: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M24 4s14 15 14 26a14 14 0 0 1-28 0C10 19 24 4 24 4z"></path><path d="M17 31c2 4 6 6 11 5"></path></svg>',
      gift: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M8 19h32v23H8z"></path><path d="M6 13h36v8H6z"></path><path d="M24 13v29"></path><path d="M24 13c-8 0-11-8-6-10 4-2 6 4 6 10z"></path><path d="M24 13c8 0 11-8 6-10-4-2-6 4-6 10z"></path></svg>',
      gauge: '<svg viewBox="0 0 100 100" fill="currentColor" aria-hidden="true" focusable="false"><path d="m49.6 11.6c-26.9 0.1-48.1 22.9-48 48.3 0.1 8.9 2.2 17.3 7.1 26.1 1 1.6 1.3 2.4 3.7 2.4 9.5 0 66.7 0.1 77.6 0 0.7-0.1 1.2-0.5 1.4-0.8 3.6-5.3 5.8-11.3 6.8-18 3.7-24.3-10.6-45.7-30.9-54.1-5.5-2.2-11.4-3.9-17.7-3.9zm36.7 70c-0.1 0.3-0.2 0.4-0.3 0.5h-72c-0.2-0.1-0.3-0.4-0.4-0.5-3.3-5.4-5.6-12.8-5.6-21.2 0.1-19.8 16.3-40 38.7-41.7 3.8-0.2 7.7-0.1 11.6 0.7 16.3 3 30.9 16.9 33.6 35.1 1.2 9.3-1 20.6-5.6 27.1z"></path><path d="m71.2 37.5c-4.1 3.7-11.1 10.1-17 15.3-1.7 1.4-2.6 0.8-4.5 1-5.5 0.2-10.3 5-10.3 10.4 0.1 4.7 3.6 10.2 9.7 10.1 6.1-0.2 10.4-5.2 10.3-11.4-0.1-3.1-0.7-3.4 1.2-5.9l13-17.1c1.7-2.1-0.6-4.1-2.4-2.4zm-22.1 27.8c-1.4 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.7 1.2 2.7 2.8c0 1.4-1.3 2.8-2.7 2.8z"></path><path d="m45.9 28.9c0 1.8 0.2 4.6 3.3 4.6 2.3 0 3.2-1.9 3.2-4 0.1-3.1-1.2-4.7-3.2-4.8-1.8 0-3.3 1.2-3.3 4.2z"></path><path d="m17 56.7c-2.1 0-4.3 1-4.3 3.3 0.1 2.3 1.7 3.3 4.1 3.3 2.5 0 4.6-1 4.6-3.4-0.1-1.9-1.7-3.2-4.4-3.2z"></path><path d="m83.3 56.7c-2.2-0.1-4.7 0.9-4.7 3.3 0 2 1.4 3.4 4.1 3.4 2.7 0.1 4.7-1 4.9-3.1 0.1-2-1.4-3.6-4.3-3.6z"></path><path d="m27.9 35.2c-1.4 0-2.9 1.3-2.9 3.1 0.1 1.6 1.4 3.1 3.1 3.1 1.5 0 2.7-1.4 2.7-2.9 0-1.6-1.2-3.2-2.9-3.3z"></path></svg>',
      shield: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M24 4l17 7v12c0 11-7 18-17 21C14 41 7 34 7 23V11l17-7z"></path><path d="M17 24l5 5 10-11"></path></svg>',
      star: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M24 4l6 13 14 2-10 10 2 14-12-7-12 7 2-14L4 19l14-2 6-13z"></path></svg>',
      factory: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 42h36"></path><path d="M9 42V22l11 7V18l11 8V12h8v30"></path><path d="M14 36h4M24 36h4M34 36h4"></path></svg>',
      chat: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M8 10h32v22H20L10 40v-8H8z"></path><path d="M17 21h.1M24 21h.1M31 21h.1"></path></svg>',
      tag: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 25L25 5h16v16L21 41z"></path><circle cx="34" cy="14" r="3"></circle></svg>',
      ruler: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M8 31L31 8l9 9-23 23z"></path><path d="M18 21l4 4M23 16l4 4M13 26l4 4M28 11l4 4"></path></svg>'
    };

    return icons[name] || icons.spark;
  }

  function initAll() {
    document.querySelectorAll('[data-custom-quick-product-facts]').forEach(renderRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-custom-quick-product-facts]');

    if (root) {
      renderRoot(root);
    }
  });
})();
